import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import SocialMedia from '../SocialMedia/SocialMedia';
import SocialMediaLayoutColumn from '../SocialMedia/SocialMediaLayoutColumn';
import Input from '../Input';
import Button from '../Buttons';

// Capa general
const StyledOptionsNews = styled.div`
  width: 2rem;
  margin-top: 0;
  ${mediaqueries.greaterThan('mobile')`
    width: 9.75rem;
  `};

  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.readAfter &&
      css`
        width: 2rem;
      `};
  `};
`;

// Capa para organizar los iconos
const StyledOptionsIcons = styled(SocialMedia)`
  left: 0;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;

  margin-bottom: 0.375rem;
  align-items: center;
  display: none;
  background-color: ${props => props.theme.colors.dark}FC;

  ${props =>
    props.activeMobile &&
    css`
      display: flex;
    `};

  ${mediaqueries.greaterThan('mobile')`
      position: static;
      align-items: baseline;
      display: flex;      
      background-color: transparent;
      height: auto;
      width: auto;
  `};

  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.activeMobile &&
      css`
        display: flex;
      `};
  `};
`;

const StyledOptionsIconsColumn = styled(SocialMediaLayoutColumn)`
  left: 0;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;

  margin-bottom: 0.375rem;
  align-items: center;
  display: none;
  background-color: ${props => props.theme.colors.dark}FC;

  ${props =>
    props.activeMobile &&
    css`
      display: flex;
    `};

  ${mediaqueries.greaterThan('mobile')`
      position: static;
      align-items: baseline;
      display: flex;      
      background-color: transparent;
      height: auto;
      width: auto;
  `};

  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.readAfter &&
      css`
        left: 0;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;

        margin-bottom: 0.375rem;
        align-items: center;
        display: none;
        background-color: ${props => props.theme.colors.dark}FC;
      `};

    ${props =>
      props.activeMobile &&
      css`
        display: flex;
      `};
  `};
`;

// // Capa auxiliar que sale cuando seleccionamos el like y readLater,
const StyledBoxOption = styled.div`
  display: none;
  height: 100%;
  background-color: ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.light};
  opacity: 0;
  padding: 0 0 0.125rem;
  text-align: center;
  transition: all 0.5s ease-in-out;
  width: 100%;

  ${props =>
    props.active &&
    css`
      display: inline-block;
      opacity: 1;
    `};

  ${mediaqueries.greaterThan('mobile')`
    position: static;
    display: block;
    height: auto;
    width: auto;
  `};
`;

// Texto de las capas auxiliares
const StyledBoxText = styled.div`
  width: 100%;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('18px')};
  margin: 0.48rem 0 ${rem('10px')} 0;
  min-height: ${rem('24px')};
  color: ${props => props.theme.colors.light};

  ${props =>
    props.darkTitle &&
    css`
      color: ${props => props.theme.colors.dark};
    `};
`;

const StyledBoxLeyend = styled.p`
  width: 100%;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  margin: 0 0 ${rem('10px')} 0;
  line-height: 1.2;
  color: ${props => props.theme.colors.light};

  ${props =>
    props.darkTitle &&
    css`
      color: ${props => props.theme.colors.dark};
    `};
`;

// capa auxiliar de Share
const StyledBoxShare = styled(StyledBoxOption)`
  height: 100%;
  padding: ${rem('5px')} ${rem('15px')};
  display: none;
  position: absolute;
  transition: all 0.5s;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.93);
  ${props =>
    props.activeShare &&
    css`
      display: flex;
      opacity: 1;
      flex-direction: column;
      width: 100%;
      align-items: center;
      justify-content: center;
    `};
`;
// Icono Cerrar para capa de Share
const StyledClose = styled(Icon)`
  position: absolute;
  top: ${rem('5px')};
  right: ${rem('5px')};
  margin: 0.9rem;
`;
// Capa para organizar el formulario de enviar mail en el centro de la caja negra
const StyledBoxSend = styled.div`
  width: 100%;
  text-align: left;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  ${mediaqueries.greaterThan('mobile')`
    width: 22rem;
  `};
`;

// ** ICONOS **
// Icono de cerrar opciones en mobile
const StyledOptionsClose = styled(Icon)`
  width: 1.1875rem;
  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};

  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.readAfter &&
      props.activeMobile &&
      `
          display: block;
      `};
  `};
`;

// Icono para movil de los tres puntos
const StyledIconPoints = styled(Icon)`
  margin-top: 0;
  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};

  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.readAfter &&
      `
        display: block;
    `};
  `};
`;
const StyledInputMail = styled(Input)`
  margin-bottom: ${rem('22px')};
`;
const StyledInputSubmit = styled(Button)`
  align-self: flex-end;
`;

const StyledMsg = styled.p`
  font-family: ${props => props.theme.fonts.bold};
`;

export {
  StyledBoxOption,
  StyledBoxSend,
  StyledBoxShare,
  StyledBoxText,
  StyledBoxLeyend,
  StyledClose,
  StyledIconPoints,
  StyledOptionsClose,
  StyledOptionsIcons,
  StyledOptionsIconsColumn,
  StyledOptionsNews,
  StyledInputMail,
  StyledInputSubmit,
  StyledMsg
};
